import React from 'react';
import { useSelector } from 'react-redux';
import Behaviour from 'components/prism/behaviour';
import Rating from 'components/prism/rating';
import { Paging, ArrayHelpers } from '@salesperformanceint/e4shared';
import Subheader from 'components/prism/subheader';

export const Explore = ({ text, data, loading }) => {
    const { prismMultiColumn } = useSelector(state => state.ui);
    const pageSize = 15;
    const [page, setPage] = React.useState(1);

    // Sort data by area alphabetically first, then by name
    const sortedData = React.useMemo(() => {
        return data?.sort((a, b) => {
            const areaCompare = a.area.localeCompare(b.area);
            if (areaCompare !== 0) return areaCompare;
            return a.name.localeCompare(b.name);
        }) || [];
    }, [data]);

    // Get paginated data using ArrayHelpers
    const paginatedData = React.useMemo(() => {
        if (!sortedData?.length) return [];
        return ArrayHelpers.getPage(sortedData, page, pageSize) || [];
    }, [sortedData, page, pageSize]);

    // Group paginated data by area
    const groupedData = React.useMemo(() => {
        if (!paginatedData?.length) return {};

        return paginatedData.reduce((groups, item) => {
            const area = item.area;
            if (!groups[area]) {
                groups[area] = [];
            }
            groups[area].push(item);
            return groups;
        }, {});
    }, [paginatedData]);

    return (
        <>
            <Subheader title={text.explore} count={data?.length} />
            {Object.entries(groupedData).map(([areaName, items]) => (
                <div key={areaName} className="mb30">
                    <h3 className="mb20">
                        {areaName} <Rating level={items[0]?.areaLevel} />
                    </h3>
                    <div className={prismMultiColumn ? 'even-col' : ''}>
                        {items.map(item => (
                            <Behaviour key={`recommended-${item.id}`} padBottom={!prismMultiColumn} item={item} />
                        ))}
                    </div>
                </div>
            ))}
            {!loading && data.length > pageSize && (
                <div className="mt10 text-center behaviour-paging">
                    <Paging recordCount={data.length} page={page} pageSize={pageSize} goToPage={setPage} />
                </div>
            )}
        </>
    );
};

export default Explore;
